/* eslint-disable no-magic-numbers */
import { FormattedMessage } from '@futrli/localisation';
import { UISystemIcon } from '@futrli/ui-components';
import clsx from 'clsx';
import React from 'react';
import { SIZES } from '../../../../../core/constants';
import { getRowHeightSize } from '../../user-grid-settings/user-grid-settings-actions';
import { UserGridSettingsContext } from '../../user-grid-settings/user-grid-settings-context';
import { nestedAccountHeightOverride } from '../style-rows';
import { SheetsAssumptionRow } from '../types';
import { PredictionsAccountCategories, VIEW_TYPES } from '../../../../../core/types';
import { getColors } from '../style-rows';

import grid from '../../../../../ui/data-grid/components/grid.scss';
import styles from './header-row.scss';
import { MARGIN_LEFT_LEVEL } from './header-row-utils';
import Tooltip from 'carbon-react/lib/components/tooltip';

interface Props {
  isLast?: boolean;
  level: number;
  row: SheetsAssumptionRow;
  wrapperStyle: React.CSSProperties;
  category?: PredictionsAccountCategories;
  viewType?: VIEW_TYPES;
}

export const HeaderRowSheetsAssumption: React.FC<Props> = React.memo(
  ({ row, level, isLast, wrapperStyle, category, viewType }) => {
    const { rowHeights } = React.useContext(UserGridSettingsContext);
    const rowHeight = getRowHeightSize(rowHeights);
    const assumptionsRowHeightOverride = nestedAccountHeightOverride(row, rowHeight, level as number);

    const headerRowClasses = clsx({
      [grid.rowHeader]: true,
      [grid.isChild]: true,
      [grid.isLast]: isLast,
      [grid.isFirst]: row.siblingIndex === 0,
      [grid.isPrediction]: true
    });

    const headerRowInnerClasses = clsx({
      [grid.rowHeaderInner]: true,
      [grid[assumptionsRowHeightOverride]]: true
    });

    const iconClasses = clsx({
      [styles.sheetsIcon]: true,
      [styles.sheetsIconMedium]: assumptionsRowHeightOverride === SIZES.MEDIUM
    });

    return (
      <div className={headerRowClasses} style={wrapperStyle} role="row">
        <div
          role="cell"
          className={headerRowInnerClasses}
          style={{
            backgroundColor: getColors(category || 'income', viewType)[2],
            marginLeft: level * MARGIN_LEFT_LEVEL
          }}
        >
          <div className={clsx(grid.flexContainer, grid.flexContainerJustify)}>
            <div className={clsx(grid.title, styles.title)} data-testid="account-name">
              <Tooltip
                message={
                  <FormattedMessage
                    id="predict.imported_from_google_sheets"
                    defaultMessage="Imported from Google sheets"
                  />
                }
                position="top"
              >
                <div>
                  <UISystemIcon iconName="gsheets" className={iconClasses} />
                </div>
              </Tooltip>
              {row.account.name}
            </div>
            {/* <div style={{ width: 72, borderLeft: '1px solid #F6F7FA', height: '100%' }}></div> */}
          </div>
        </div>
      </div>
    );
  }
);
